import { render, staticRenderFns } from "./MovieItemC.vue?vue&type=template&id=0199e4c6&scoped=true&"
import script from "./MovieItemC.vue?vue&type=script&lang=js&"
export * from "./MovieItemC.vue?vue&type=script&lang=js&"
import style0 from "./MovieItemC.vue?vue&type=style&index=0&id=0199e4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0199e4c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VChip,VDivider,VHover,VIcon,VImg,VSkeletonLoader,VSlideYReverseTransition})
